import { TimelineRegion, TimelineRegionParams } from 'app/views/home/timeline/TimelineRegion';
import { Point } from 'app/contracts/Geometry';

export class TimelineRegionManager {
	private _regions: Array<TimelineRegion> = [];

	public add(params: TimelineRegionParams): void {
		this._regions.push(new TimelineRegion(params));
	}

	public tick(
		mouseCords: Point,
		containerX: number,
		containerWidth: number,
		containerHeight,
		progress: number,
		velocity: number
	): void {
		this._regions.forEach((region: TimelineRegion) => {
			region.tick(
				{
					x: mouseCords.x,
					y: mouseCords.y,
					relX: (Math.abs(containerX) + mouseCords.x) / containerWidth,
					relY: mouseCords.y / containerHeight
				},
				progress,
				velocity
			);
		});
	}
}
